// web/stubs/firebase-analytics.ts
// Este é um stub para @react-native-firebase/analytics para o ambiente web.
// Ele impede que o código nativo do Firebase seja executado no navegador.


const analytics = () => ({
  logEvent: (eventName: string, params?: {[key: string]: any}) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Firebase Analytics Stub] Event: ${eventName}`, params);
    }
  },
  logSelectContent: (eventName: string, params?: {[key: string]: any}) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Firebase Analytics Stub] Event: ${eventName}`, params);
    }
  },
  // Adicione outros métodos que você usa do analytics, se necessário, como no-ops
  setUserId: (userId: string) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Firebase Analytics Stub] Set User ID: ${userId}`);
    }
  },
  setUserProperty: (name: string, value: string) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(
        `[Firebase Analytics Stub] Set User Property: ${name} = ${value}`,
      );
    }
  },
});

export default analytics;
